import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Size/Align',
  name: 'sizeAlign',
  type: 'object',
  fields: [
    defineField({
      title: 'Align',
      name: 'align',
      type: 'string',
      options: {
        list: [
          { title: 'Top Left', value: 'topLeft' },
          { title: 'Top Right', value: 'topRight' },
          { title: 'Right', value: 'right' },
          { title: 'Bottom Right', value: 'bottomRight' },
          { title: 'Bottom Left', value: 'bottomLeft' },
          { title: 'Left', value: 'left' },
        ],
      },
      initialValue: 'bottomLeft',
    }),
    defineField({
      title: 'Text Align',
      name: 'textAlign',
      type: 'string',
      options: {
        list: [
          { title: 'Left', value: 'left' },
          { title: 'Right', value: 'right' },
        ],
      },
      initialValue: 'left',
    }),
    defineField({
      title: 'Max Width % (1-100)',
      name: 'maxWidth',
      type: 'number',
      initialValue: 100,
    }),
    defineField({
      title: 'Margin',
      name: 'margin',
      type: 'string',
      options: {
        list: [0, 2, 4, 6, 8, 10, 12, 14].map((s) => ({
          title: `${s}`,
          value: `${s}`,
        })),
      },
      initialValue: '0',
    }),
    defineField({
      title: 'Color',
      name: 'color',
      type: 'string',
      options: {
        list: ['white', 'black'].map((s) => ({
          title: `${s}`,
          value: `${s}`,
        })),
      },
      initialValue: 'white',
    }),
    defineField({
      title: 'Heading Size',
      name: 'size',
      type: 'string',
      options: {
        list: [
          'xtiny',
          'tiny',
          'xs',
          'sm',
          'base',
          'lg',
          'xl',
          '2xl',
          '3xl',
          '4xl',
          '5xl',
          '6xl',
          '7xl',
          '8xl',
          '9xl',
        ].map((s) => ({ title: s, value: s })),
      },
      initialValue: 'xl',
    }),
    defineField({
      title: 'Content Size',
      name: 'sizeContent',
      type: 'string',
      options: {
        list: [
          'xtiny',
          'tiny',
          'xs',
          'sm',
          'base',
          'lg',
          'xl',
          '2xl',
          '3xl',
          '4xl',
          '5xl',
          '6xl',
          '7xl',
          '8xl',
          '9xl',
        ].map((s) => ({ title: s, value: s })),
      },
      initialValue: 'base',
      hidden: ({ document }: { document?: any }) => !document?.hero?.content,
    }),
  ],
})